import { FC } from 'react';
import { Tooltip } from '@redislabsdev/redis-ui-components';
import { InfoIcon } from '@redislabsdev/redis-ui-icons';
import { useTheme } from 'styled-components/macro';
import { HoverAbleInfoIconProps } from './HoverableInfoIcon.types';
import * as S from './HoverableInfoIcon.style';

const HoverableInfoIcon: FC<HoverAbleInfoIconProps> = ({
  tooltipContent,
  tooltipMaxWidth,
  size = 'L',
  iconDataTestId
}) => {
  return (
    <Tooltip
      maxWidth={tooltipMaxWidth}
      content={tooltipContent}
      interactive={typeof tooltipContent !== 'string'}
    >
      <S.Wrapper {...(iconDataTestId && { 'data-testid': iconDataTestId })}>
        <InfoIcon size={size} customColor={useTheme().components.label.infoIcon.iconColor} />
      </S.Wrapper>
    </Tooltip>
  );
};

export default HoverableInfoIcon;
